require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/~/core-js/library/fn/object/keys.js
 ** module id = 429
 ** module chunks = 0
 **/